import OrdersManagement from "./OrdersManagement";
export default OrdersManagement;
